import {
  ColumnHeader,
  EarmarkDTO,
  EarmarkOptionDTO,
  OtherAssetType,
  OwnerOptionsDTO,
} from '../../OtherAssets.meta';

export const columnHeaders: ColumnHeader[] = [
  { text: 'Name' },
  { text: '' },
  { text: 'Value', align: 'right' },
  { text: 'Owner' },
];

export interface MiscAssetDTO {
  Id: string;
  Name: string;
  MarketValue: number | null;
  Owner: string;
  SaleYear: number | null;
  IsSoldAtRetirement: boolean | null;
  SaleNetEarnings: number | null;
  AssetEarmark: EarmarkDTO[];
  AssetGrowth: number;
  OtherAssetType: OtherAssetType;
  CustomBucketIndex: number | null;
  IsExcludedFromAssetBucketing: boolean;
  IsLiquid: boolean;
  IncludeInGrossEstate: boolean;
  OrionManagementStyleId: number | null;
}

export interface MiscAssetsOptionsDTO {
  ownerOptions: OwnerOptionsDTO;
  SaleYearOptions: string[];
  EarmarkOptions: EarmarkOptionDTO[];
  DefaultAssetBucketIndex: number | null;
  IsLiquid: boolean;
}
